import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";

const STATUS_OPTIONS = [
  { value: "Đang hoạt động", label: "Đang hoạt động" },
  { value: "Ngừng hoạt động", label: "Ngừng hoạt động" },
];

const CreateDepartmentPopup = ({
  closePopup,
  canEdit = true,
  initialData,
  onSubmit,
}) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    status: "Đang hoạt động",
    members: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  useEffect(() => {
    if (!initialData) return;
    setForm({
      name: initialData.name || "",
      description: initialData.description || "",
      status: initialData.status || "Đang hoạt động",
      members: initialData.members?.map((m) => m._id) || [],
    });
  }, [initialData]);

  const handleSubmit = async () => {
    if (!canEdit) return;

    if (!form.name.trim()) {
      toast.error("Vui lòng nhập tên phòng ban");
      return;
    }

    try {
      setSubmitting(true);
      await onSubmit?.(form);
      toast.success(
        initialData
          ? "Cập nhật phòng ban thành công!"
          : "Tạo phòng ban thành công!",
      );
      closePopup();
    } catch {
      toast.error("Thao tác thất bại. Vui lòng thử lại.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancelClick = () => {
    setShowCancelConfirm(true);
  };

  const handleCancelConfirm = () => {
    setShowCancelConfirm(false);
    closePopup();
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={canEdit ? handleCancelClick : closePopup}
        title={initialData ? "Chỉnh sửa phòng ban" : "Tạo mới phòng ban"}
        maxWidth="520px"
        maxHeight="90vh"
        primaryButtonText={
          canEdit ? (submitting ? "Đang lưu..." : "Lưu") : null
        }
        primaryButtonOnClick={handleSubmit}
        showCancelButton={true}
        cancelButtonText={canEdit ? "Hủy" : "Đóng"}
      >
        <div className="px-6 py-6 space-y-5">
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Tên phòng ban <span className="text-red-500">*</span>
            </label>
            <CustomInput
              disabled={!canEdit || submitting}
              value={form.name}
              placeholder="Nhập tên phòng ban"
              onChange={(value) => setForm((p) => ({ ...p, name: value }))}
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Mô tả</label>
            <CustomInput
              type="textarea"
              rows={4}
              disabled={!canEdit || submitting}
              value={form.description}
              placeholder="Mô tả chức năng phòng ban"
              onChange={(value) =>
                setForm((p) => ({ ...p, description: value }))
              }
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Trạng thái
            </label>
            <CustomSelect
              disabled={!canEdit || submitting}
              options={STATUS_OPTIONS}
              value={STATUS_OPTIONS.find((o) => o.value === form.status)}
              onChange={(option) =>
                setForm((p) => ({ ...p, status: option.value }))
              }
              required
            />
          </div>
        </div>
      </Modal>

      {canEdit && (
        <Modal
          isOpen={showCancelConfirm}
          onClose={() => setShowCancelConfirm(false)}
          title="Xác nhận hủy"
          maxWidth="400px"
          primaryButtonText="Đồng ý"
          primaryButtonOnClick={handleCancelConfirm}
          showCancelButton={true}
          cancelButtonText="Quay lại"
        >
          <div className="px-6 py-4">
            <p className="text-gray-700">
              Bạn có chắc chắn muốn hủy thao tác không?
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Các thay đổi chưa lưu sẽ bị mất.
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default CreateDepartmentPopup;
